export const IVIDEON_PLANS_OPTIONS = ["name", "price"];
